import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ID} from "../../../core/metamodel/metaConstant";
import {LovItem} from "../../../core/metamodel/mdEntity";

@entityConfig()
export class ProjectVersionRunoffCoefficient extends DomainAncestor {
  @observable runoffCoefficientId: number
  @observable name: string;
  @observable lower: number;
  @observable between: number;
  @observable over: number;
  @observable projectVersion : LovItem;


  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.runoffCoefficientId;
  }

  public setId(id: ID): void {
    this.runoffCoefficientId = <number>id;
  }
}




// WEBPACK FOOTER //
// ./src/sbtool/domain/project/projectRunoffCoefficientDomain.ts